module.exports = __webpack_public_path__ + "img/contact_demo.8d919da9.png";